import { CoreEvent, eventNames } from '@carvana/core-events';
import { useEffect } from 'react';

export default function useEventListeners(
  setShouldRefreshSoftPull: () => void
) {
  useEffect(() => {
    function refreshWithFinancing() {
      setShouldRefreshSoftPull();
    }

    CoreEvent.on(eventNames.softpullModal.success, refreshWithFinancing);

    return () => {
      CoreEvent.off(eventNames.softpullModal.success, refreshWithFinancing);
    };
  }, [setShouldRefreshSoftPull]);
}
